import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { reduxForm, Field } from 'redux-form';
import styles from '../styles/pages/signin.scss';

const rxEmailValidator = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+[.]{1}[a-zA-Z]{2,}$/;

// eslint-disable-next-line import/no-mutable-exports
let SignInForm = (props) => {
    const {
        intl, valid, submitting, handleSubmit,
    } = props;

    const [state, setState] = useState({
        showPassword: true,
        rememberMe: true,
        isEmailError: false,
        user: {
            email: '',
            password: '',
        },
        isShowCode: false,
    });

    const onSubmit = (formData) => {
        setState({
            ...state,
            isShowCode: true,
        });
        props.onSubmitCallback(formData);
    };

    const toggleShowPassword = () => {
        setState({
            ...state,
            showPassword: !state.showPassword,
        });
    };

    const toggleRememberMe = () => {
        setState({
            ...state,
            rememberMe: !state.rememberMe,
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setState({
            ...state,
            isEmailError: name === 'user[email]' ? !rxEmailValidator.test(value) : state.isEmailError,
            user: {
                email: name === 'user[email]' ? value : state.user.email,
                password: name === 'user[password]' ? value : state.user.password,
            },
        });
    };

    return (
        <div>
            <form
                className={styles.form}
                onSubmit={handleSubmit(onSubmit)}
            >
                <div>
                    <div className={`form-group ${styles.formGroup}`}>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 holder" style={{ paddingBottom: '5px' }}>
                            <Field
                                disabled={state.isShowCode}
                                className={styles.formInput}
                                name="user[email]"
                                component="input"
                                type="text"
                                autoComplete="off"
                                placeholder={intl.formatMessage({
                                    id: 'email-address',
                                    defaultMessage: 'Email Address',
                                })}
                                onChange={(e) => {
                                    handleInputChange(e);
                                }}
                                style={
                                    {
                                        opacity: state.isShowCode ? '0.5' : '',
                                        // borderColor: state.isEmailError ? 'red' : '',
                                    }
                                }
                            />
                            {
                                state.isEmailError && (
                                    <span style={{
                                        position: 'absolute',
                                        bottom: '0',
                                        color: '#d3af71',
                                        fontSize: '12px',
                                        paddingLeft: '6px',
                                    }}
                                    >
                                        <FormattedMessage
                                            id="invalid-email-address"
                                            defaultMessage="Invalid email address."
                                        />
                                    </span>
                                )
                            }
                        </div>
                    </div>
                    {
                        !state.isShowCode && (
                            <span
                                style={{
                                    display: 'flex',
                                    textAlign: 'justify',
                                    marginBottom: '15px',
                                    padding: '0 5px',
                                    fontWeight: 600,
                                    color: '#999',
                                }}
                            >
                                <FormattedMessage
                                    id="send-message-code-by-email"
                                    defaultMessage="An email will be sent to your email account with a temporary access code to start the section."
                                />
                            </span>
                        )
                    }
                    {
                        state.isShowCode && (
                            <div className={`form-group ${styles.formGroup}`}>
                                <div className={`col-lg-12 col-md-12 col-sm-12 col-xs-12 ${styles.inputGroupEdited}`}>
                                    <Field
                                        className={styles.formInput}
                                        name="user[password]"
                                        component="input"
                                        autoComplete="off"
                                        type={state.showPassword ? 'text' : 'password'}
                                        placeholder={intl.formatMessage({
                                            id: 'code',
                                            defaultMessage: 'Code',
                                        })}
                                        onChange={(e) => {
                                            handleInputChange(e);
                                        }}
                                    />
                                </div>
                            </div>
                        )
                    }
                    {
                        state.isShowCode && (
                            <span
                                style={{
                                    display: 'flex',
                                    textAlign: 'justify',
                                    marginBottom: '15px',
                                    padding: '0 5px',
                                    fontWeight: 600,
                                    color: '#999',
                                }}
                            >
                                <FormattedMessage
                                    id="send-message-code-by-email-finished"
                                    defaultMessage="An email has been sent to your email account with a temporary access code to start the section."
                                />
                            </span>
                        )
                    }
                </div>
                <div className={`form-group ${styles.formGroupHolder}`}>
                    <button
                        className="form-control btn btn-default"
                        type="submit"
                        disabled={!valid || submitting || state.isEmailError || (!state.user.password && state.isShowCode) || !state.user.email}
                    >
                        {
                            !state.isShowCode && <span><FormattedMessage id="send-code-to-email" defaultMessage="Send code to email" /></span>
                        }
                        {
                            state.isShowCode && <span><FormattedMessage id="signin" defaultMessage="Sign In" /></span>
                        }
                    </button>
                </div>
            </form>
        </div>
    );
};

SignInForm = reduxForm({
    form: 'signIn',
})(SignInForm);

export default injectIntl(SignInForm);



/** WEBPACK FOOTER **
 ** ./src/components/shared/sign-in-form.js
 **/